import React from "react";
import { Box, Grid, Typography, Avatar } from "@mui/material";
import { VoiceItem } from "@/models/goFurther";
import { FONT_SIZE, FONT_WEIGHT, TEXT_COLOR, BACKGROUND_COLOR } from "../GoFurtherStyles";
import { SectionGridItemCard } from "./GoFurtherPrimitives";

interface GoFurtherMotivationSectionProps {
  voiceItems: VoiceItem[];
}

const GoFurtherMotivationSection: React.FC<GoFurtherMotivationSectionProps> = ({ voiceItems }) => (
  <SectionGridItemCard
    title={
      <Typography component="h2" sx={{ fontWeight: FONT_WEIGHT.BOLD, fontSize: FONT_SIZE.headline5 }}>
        外部充電器をご利用頂いた乗務員様の声
      </Typography>
    }
  >
    <Grid item>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          columnGap: 2,
          rowGap: 3,
        }}
      >
        {voiceItems.map((item) => (
          <Box key={item.id}>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, p: 0 }}>
              <Avatar src="/driver_icon.png" alt="乗務員アイコン" sx={{ width: 44, height: 44 }} />
              <Box
                sx={{
                  flex: 1,
                  bgcolor: BACKGROUND_COLOR.SECONDARY,
                  borderRadius: 3,
                  p: 2,
                  height: "88px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: FONT_SIZE.body2, color: TEXT_COLOR.PRIMARY }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Grid>
  </SectionGridItemCard>
);

export default GoFurtherMotivationSection;
